var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.705 11.66L14.3763 4.18496C13.991 3.79193 13.3264 4.06681 13.3264 4.61922V8.90762C9.68885 8.90762 2.55714 11.2598 2.00069 20.4832C1.97729 20.8711 2.55082 21.1472 2.85998 20.9148C4.97351 19.326 10.2578 15.8599 13.3264 15.8599V20.1483C13.3264 20.7007 13.991 20.9755 14.3763 20.5825L21.705 13.1075C22.0983 12.7063 22.0983 12.0611 21.705 11.66Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.6b70836369680b23caa78d9fa6e01f2c.svg";
export { ForwardRef as ReactComponent };